/**
 * Safely extract a user-facing string from an axios error response.
 *
 * FastAPI returns 422 validation errors as:
 *   { detail: [{ type, loc, msg, input, url }, ...] }
 *
 * Trying to render that object directly in a toast / JSX child crashes
 * React with "Objects are not valid as a React child". This helper ALWAYS
 * returns a string so the error chain stays safe regardless of shape.
 */
export const apiErrorMessage = (err, fallback = "Ocurrió un error inesperado") => {
  if (!err) return fallback;
  // Network / no response
  if (!err.response) return err.message || fallback;
  const data = err.response.data;
  if (!data) return `${err.response.status} ${err.response.statusText || ""}`.trim() || fallback;
  // Plain string
  if (typeof data === "string") return data;
  // { detail: "..." }
  if (typeof data.detail === "string") return data.detail;
  // FastAPI validation: { detail: [{msg, loc, ...}] }
  if (Array.isArray(data.detail)) {
    const parts = data.detail
      .map((e) => {
        if (typeof e === "string") return e;
        if (e && typeof e.msg === "string") {
          const loc = Array.isArray(e.loc) ? e.loc.filter((x) => x !== "body").join(".") : "";
          return loc ? `${loc}: ${e.msg}` : e.msg;
        }
        return "";
      })
      .filter(Boolean);
    if (parts.length) return parts.join(" · ");
  }
  // { message: "..." } or { error: "..." }
  if (typeof data.message === "string") return data.message;
  if (typeof data.error === "string") return data.error;
  return fallback;
};
